import React from 'react'

import * as styles from './Stepper.css'
import IconCheck from '@/icons/info/iconVector'
import classNames from 'classnames'

type Step = {
  id: string
  label?: string | React.ReactNode
  ariaLabel: React.AriaAttributes['aria-label']
}

export type StepperProps = {
  steps: Step[]
  activeStep: number
}

const Stepper = ({ steps = [], activeStep = 0 }: StepperProps) => {
  const stepsAndConnectors = steps.map((step, index) => {
    const isActive = index === activeStep
    const isCompleted = index < activeStep

    return (
      <React.Fragment key={step.id}>
        <div
          className={styles.Step}
          role="listitem"
          aria-label={step.ariaLabel}
          aria-current={isActive ? 'step' : undefined}
        >
          <div
            className={classNames(
              styles.StepNumber,
              isActive && styles.StepNumberActive,
              isCompleted && styles.StepNumberCompleted
            )}
          >
            {isCompleted ? (
              <IconCheck className={styles.StepNumberIcon} />
            ) : (
              index + 1
            )}
          </div>
          {step.label && (
            <span
              className={classNames(
                styles.StepLabel,
                (isActive || isCompleted) && styles.StepLabelActive
              )}
            >
              {step.label}
            </span>
          )}
        </div>

        {index < steps.length - 1 && (
          <div
            className={classNames(
              styles.StepConnector,
              isCompleted && styles.StepConnectorCompleted,
              isActive && styles.StepConnectorActive,
              !!step.label && styles.StepConnectorWithLabel
            )}
          />
        )}
      </React.Fragment>
    )
  })

  return (
    <div
      className={styles.StepperContainer}
      role="navigation"
      aria-label="Progress steps"
    >
      <div className={styles.StepsWrapper}>{stepsAndConnectors}</div>
    </div>
  )
}

export default Stepper
